import { Component, effect, input, output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Make } from '../../../../core/models/vehicle.model';

@Component({
  selector: 'app-make-select',
  imports: [NgSelectComponent, ReactiveFormsModule],
  templateUrl: './make-select.html',
  styleUrl: './make-select.scss',
})
export class MakeSelect {
  readonly makes = input<Make[]>([]);
  readonly loading = input(false);
  readonly error = input<string | null>(null);
  readonly selectedId = input<number | null>(null);

  readonly selectionChange = output<number | null>();

  readonly control = new FormControl<number | null>(null);

  constructor() {
    effect(() => {
      const id = this.selectedId();
      if (this.control.value !== id) {
        this.control.setValue(id, { emitEvent: false });
      }
    });

    effect(() => {
      if (this.loading()) {
        this.control.disable({ emitEvent: false });
      } else {
        this.control.enable({ emitEvent: false });
      }
    });

    this.control.valueChanges.subscribe((value) => this.selectionChange.emit(value));
  }
}
